import { useGetDutchiePosLoyaltyConfig } from 'src/components/loyalty/use-get-dutchie-pos-loyalty-config';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import type { Dispensaries } from 'src/gql/graphql';

type UseEarlyThemeDispensaryParams = {
  enterpriseId?: string;
  /** Two-letter state code, no "US-" prefix. */
  regionCode?: string;
  /** False once an authoritative dispensary is available. */
  enabled: boolean;
};

/**
 * POS-17999 -- resolves a dispensary from just a region guess (no login/state confirmation),
 * so the landing page can show real brand colors before the user does anything. Separate from
 * the "real" getDutchiePosLoyaltyConfig call in index.tsx, which needs a known user identity
 * and only resolves well after first render.
 */
export function useEarlyThemeDispensary({
  enterpriseId,
  regionCode,
  enabled,
}: UseEarlyThemeDispensaryParams): Dispensaries | undefined {
  const isoRegionCode = regionCode ? `US-${regionCode}` : undefined;

  const { data } = useGetDutchiePosLoyaltyConfig({
    enterpriseId,
    isoRegionCode,
    skip: !enabled || !enterpriseId || !isoRegionCode,
  });

  const { dispensary } = useDispensary(enabled ? data?.dispensaryId ?? undefined : undefined);

  return enabled ? dispensary : undefined;
}
